import { render, staticRenderFns } from "./RegulatoryInformationForShipping.vue?vue&type=template&id=6f95aa53"
import script from "./RegulatoryInformationForShipping.vue?vue&type=script&lang=js"
export * from "./RegulatoryInformationForShipping.vue?vue&type=script&lang=js"
import style0 from "./RegulatoryInformationForShipping.vue?vue&type=style&index=0&id=6f95aa53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports